<template>
    <div :class="classes" class="d-flex filterbar grow flex-wrap">
        <div
            :class="{ 'd-sm-none': !$slots['visible-filter'] }"
            class="d-flex justify-content-between align-items-center grow gap-5 sm:max-w-[350px]"
        >
            <slot :is-open="isOpen" :is-processing="isProcessing" name="visible-filter">
                <div />
            </slot>
            <button
                v-if="$slots.default && modelValue === null"
                class="btn-text d-flex align-items-center d-sm-none gap-1"
                style="min-height: 44px"
                @click.stop="toggleFilterbar"
            >
                <spinner v-if="isProcessing" />
                <icon v-else icon="cil-list-filter" style="position: relative; top: -1px" />
                <span>{{ trans('general.table.filter.label') }}</span>
            </button>
            <button
                v-if="showClearButton && !$slots.default"
                :class="{ 'opacity-100': isProcessing }"
                :disabled="!active"
                class="btn btn-text d-none d-sm-block position-relative mt-1 px-3 text-center"
                style="min-width: 0"
                @click="$emit('clear')"
            >
                <span
                    v-if="isProcessing"
                    class="d-flex position-absolute d-flex justify-content-center align-items-center"
                    style="top: 0; right: 0; bottom: 0; left: 0"
                >
                    <spinner />
                </span>
                <span :style="{ visibility: isProcessing ? 'hidden' : 'visible' }">{{ trans('general.action.clear') }}</span>
            </button>
        </div>
        <collapse v-if="$slots.default" :show="isOpen" class="d-sm-flex grow">
            <div :class="classes" class="flex flex-wrap gap-1" style="min-height: 36px">
                <slot />
                <div class="relative ml-auto flex items-center justify-between">
                    <slot name="filter-end">
                        <button
                            :class="{ 'opacity-100': isProcessing }"
                            :disabled="!active"
                            class="btn btn-text px-3 text-center"
                            style="min-width: 0"
                            @click="$emit('clear')"
                        >
                            <span
                                v-if="isProcessing && !isSmallScreen"
                                class="absolute flex items-center justify-center"
                                style="top: 0; right: 0; bottom: 0; left: 0"
                            >
                                <spinner />
                            </span>
                            <span
                                :style="{
                                    visibility: isProcessing && !isSmallScreen ? 'hidden' : 'visible',
                                }"
                                >{{ trans('general.action.clear') }}</span
                            >
                        </button>
                    </slot>
                </div>
                <slot v-if="$slots.addon" name="addon" />
            </div>
        </collapse>
    </div>
</template>
<script>
import JetButton from '@/Jetstream/Button.vue';
import Collapse from '@/Components/Collapse.vue';
import Spinner from '@/Components/Spinner.vue';

export default {
    name: 'CollapsableFilterBar',
    components: { Spinner, Collapse, JetButton },
    props: {
        active: {
            type: Boolean,
            default: false,
        },
        isProcessing: {
            type: Boolean,
            default: false,
        },
        showClearButton: {
            type: Boolean,
            default: true,
        },
        modelValue: {
            type: Boolean,
            default: null,
        },
    },
    emits: ['update:modelValue', 'clear'],
    data() {
        return {
            internalIsOpen: false,
            width: document.body.clientWidth,
        };
    },
    computed: {
        classes() {
            let classes = [];

            if (this.$slots['visible-filter']) {
                classes.push('gap-3');
            }

            if (this.$slots['addon']) {
                classes.push('grow');
            }

            if (this.isSmallScreen) {
                classes.push('flex-column', 'grow');
            } else {
                classes.push('flex-row', 'align-items-center');
            }

            return classes;
        },
        isOpen: {
            get() {
                return this.modelValue !== null ? this.modelValue : this.internalIsOpen;
            },
            set(value) {
                if (this.modelValue !== null) {
                    this.$emit('update:modelValue', value);
                } else {
                    this.internalIsOpen = value;
                }
            },
        },
    },
    created() {
        window.addEventListener('resize', this.updateSize);
        this.updateSize();
    },
    destroyed() {
        window.removeEventListener('resize', this.updateSize);
    },
    methods: {
        updateSize() {
            this.width = document.body.clientWidth;

            if (!this.isSmallScreen) {
                this.isOpen = true;
            }
        },
        toggleFilterbar() {
            if (this.isProcessing) {
                return;
            }

            this.isOpen = !this.isOpen;
        },
        setIsOpen(value) {
            this.isOpen = value;
        },
    },
};
</script>
